module.exports = __webpack_public_path__ + "img/78.2fad5810.jpg";